export const defaultSettings = {
  brandName: 'OmsorgBygg.no',
  heroTitle: 'Trygge boliger og bygg til leie – fra en utleier du kan stole på.',
  heroDescription:
    'OmsorgBygg eier og leier ut boliger og omsorgsbygg over hele landet. Vi legger vekt på god standard, ryddige leieforhold og en enkel prosess for deg som leter etter riktig bolig.',
  highlights: [
    'Oversikt over ledige boliger og bygg til leie',
    'Tydelig informasjon om adresse, størrelse, leie og tilgjengelighet',
    'Personlig oppfølging gjennom hele leieforholdet',
  ],
  portfolioStats: [
    { label: 'Eiendommer i porteføljen', value: '15' },
    { label: 'Ledige nå', value: '08' },
  ],
  propertyTypes: [
    {
      title: 'Hus',
      description:
        'Frittstående boliger med god plass og fleksible planløsninger for ulike behov.',
    },
    {
      title: 'Leilighet',
      description:
        'Moderne boenheter med effektiv arealbruk, ofte sentral beliggenhet og enkel adkomst.',
    },
    {
      title: '2-mannsbolig',
      description:
        'To selvstendige boliger på samme adresse, godt egnet for familie, utleie eller generasjonsbolig.',
    },
    {
      title: 'Tomt',
      description:
        'Ubebygde tomter med muligheter for utvikling, oppføring eller langsiktig investering.',
    },
  ],
};

export const emptyPropertyForm = {
  name: '',
  address: '',
  areaCode: '',
  type: 'Hus',
  size: '',
  rooms: '',
  bathrooms: '',
  availableFrom: '',
  availability: 'ledig',
  facilities: [],
  summary: '',
  imageUrl: '',
  images: [],
};